// Constants.
// -----------------------------------------------------------------------------
export const MAP_TD_ALIGN = {
    actions: 'left',
    badge: 'left',
    button: 'left',
    free: 'left',
    icon: 'left',
    number: 'right',
    text: 'left'
};
//# sourceMappingURL=ControlledRows.contants.js.map